var _circle, _circle2, _circle3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#263360",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.59,
    y1: 13.51,
    x2: 15.42,
    y2: 17.49
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.41,
    y1: 6.51,
    x2: 8.59,
    y2: 10.49
  })));
};
export default SvgSocial;